import { useNewTranslations } from '@/common/translations';
import { Section } from '@/ui/components';

import { RowLabelAndCircularGraph, TeamsJerseys } from '../../../components';
import { ApiWidgetType, StatsTypes } from '../../../constants';
import { useStatsData } from '../../../hooks';

const OverGoals = () => {
  const translate = useNewTranslations();
  const { teams, widget } = useStatsData({
    widgetType: StatsTypes.OVER_GOALS,
  });

  if (!widget || widget.type !== ApiWidgetType.OVER_GOALS || !widget?.data) {
    return null;
  }

  const { home: homeStats, away: awayStats } = widget.data;

  return (
    <Section name={translate('PreMatchStats.OverGoals')} contentClassName="flex flex-col gap-2">
      <TeamsJerseys
        homeJerseySrc={teams.home.jersey}
        awayJerseySrc={teams.away.jersey}
        homeTeamName={teams.home.name}
        awayTeamName={teams.away.name}
      />
      <RowLabelAndCircularGraph
        label={translate('PreMatchStats.OverGoals15')}
        homeNumber={homeStats.over15Goals / 100}
        awayNumber={awayStats.over15Goals / 100}
      />
      <RowLabelAndCircularGraph
        label={translate('PreMatchStats.OverGoals25')}
        homeNumber={homeStats.over25Goals / 100}
        awayNumber={awayStats.over25Goals / 100}
      />
      <RowLabelAndCircularGraph
        label={translate('PreMatchStats.Over05HT')}
        homeNumber={homeStats.over05GoalsHT / 100}
        awayNumber={awayStats.over05GoalsHT / 100}
      />
      <RowLabelAndCircularGraph
        label={translate('PreMatchStats.Over15HT')}
        homeNumber={homeStats.over15GoalsHT / 100}
        awayNumber={awayStats.over15GoalsHT / 100}
      />
    </Section>
  );
};

export default OverGoals;
